// NOTE: key 'ZONE_LIST' is used by many useSelector hooks throughout the app

import registerZoneRedux from 'app/resources/zone';
import { useSelector } from 'react-redux';

const key = 'ZONE_LIST';

export const zoneListRedux = registerZoneRedux(key, ['LIST']);

export const useZoneList = () => useSelector((state) => state[key]);
